import type { MainMenuSection } from '../types/MainMenu.types'

const LABELS: Record<MainMenuSection, string> = {
  publicLobby: 'Public Lobby',
  myRooms: 'Rooms',
  meetings: 'Meetings',
  chat: 'Chat',
  profile: 'My Profile',
  settings: 'Settings',
  adminMenu: 'Admin',
  adminDashboard: 'Admin Dashboard',
  adminEnvironmentConfig: 'Environment',
  adminEntityCatalogue: 'Entity Catalogue',
  adminBillingSettings: 'Billing Settings',
  adminServerJobs: 'Server Jobs',
  adminMaps: 'Maps',
  adminTransactionalEmails: 'Transactional Emails',
  adminRoomManagement: 'Room Management',
  adminMapEditorPlugins: 'Map Editor',
  adminAllRooms: 'All Rooms',
  adminUserManagement: 'User Management',
  adminEndpointTesting: 'Endpoint Testing',
  adminProductUpdates: 'Product Updates',
  routingTest: 'Routing Test',
  companyManagement: 'My Company',
  companyOverview: 'Overview',
  companyDashboard: 'Company Dashboard',
  companySetup: 'Create Company',
  companyBilling: 'Billing',
  companyUsers: 'Users',
  companySettings: 'Company Settings',
  companyWallet: 'Wallet',
  companyDialog: 'Company',
  inviteUserDialog: 'Invite User',
  editUserDialog: 'Edit User',
  usersDialog: 'Users',
  companyRoomsDialog: 'Rooms',
}

/** Human-readable title for the current main-menu section (e.g. app bar subtitle). */
export function getMainMenuSectionLabel(section: MainMenuSection): string {
  return LABELS[section] ?? 'Sevv'
}

/**
 * Maps the active route section to the sidebar row data-mainmenu-section value
 * for scroll-into-view when opening the mobile drawer.
 */
export function getMainMenuNavScrollSection(section: MainMenuSection): string | null {
  if (section === 'publicLobby') return 'publicLobby'
  if (section === 'myRooms') return 'myRooms'
  if (section === 'meetings') return 'meetings'
  if (section === 'chat') return 'chat'
  if (section === 'profile') return 'profile'
  if (section === 'companySetup') return 'companySetup'
  if (section.startsWith('company')) return 'companyManagement'
  if (section.startsWith('admin') || section === 'routingTest') return 'adminMenu'
  return null
}
